import React, { forwardRef,useState } from 'react'


// React Icons 
import { FaMobileAlt, FaRocket,FaLaptopCode,FaFingerprint, FaShieldAlt,FaShoppingCart, FaLock,FaBullhorn } from "react-icons/fa";
import { MdOutlineDesignServices,MdInsights, MdHighQuality, MdRecordVoiceOver } from "react-icons/md";
import { BiBullseye } from "react-icons/bi";
import { AiOutlineShopping } from "react-icons/ai";




const Services = forwardRef(({ darkMode }, ref) => {
    // Animate with mouse move
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const handleMouseMove = (e) => {
        setPosition({
            x: (e.clientX / window.innerWidth - 0.5) * 30,
            y: (e.clientY / window.innerHeight - 0.5) * 30,
        });
    };
    // End Animate with mouse move
    
  return (
    <div ref={ref} id="services" onMouseMove={handleMouseMove}>  
        <div className='container-lg my-5 '>
            <div className="row">
                {/* Headline Secton -> Our Services */}
                <div className="col-md-12 text-center my-5 ">
                    <h1 className="text-center services-header responsive-HXXtext">Our<span className='highlight' style={{ color: "#c2b41e",}}> Services</span></h1>
                </div>
            {/* Animate with mouse move*/}
            <div style={{
                transform: `translate(${position.x}px, ${position.y}px)`,
                }} >
            <div className="row justify-content-center mt-5 gap-2" >
                {/* Service One Websites */}
                    <div className="col-mds-4 d-flex justify-content-center mb-4 " >
                        <div className={` services serv-one w-100 rounded-3 ${darkMode ? "bg-darkMode" : "bg-lightMode"}`}>
                            <div className='d-flex flex-wrap w-100 align-items-center justify-content-between border-bottom mb-4 pb-3'>
                            <h2 className='responsive-HXtext fw-bold pt-3'>Websites</h2>
                                <FaLaptopCode size={40} className='service-icon'/>
                        </div>
                        <p className='responsive-text mb-3'>We design and develop modern, responsive websites optimized for performance.</p>
                        <div>
                            <p className='responsive-text mb-3'><FaMobileAlt /> Responsive Design</p>
                            <p className='responsive-text mb-3'><FaRocket /> High Loading Speed</p>
                        </div>
                        <button class="animated-button" onClick={( ) => window.open("https://wa.me/201021699255/","_blank" )} >
                            <svg viewBox="0 0 24 24" class="arr-2" xmlns="http://www.w3.org/2000/svg">
                                <path
                                d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z"
                                ></path>
                            </svg>
                            <span class="text">Contact US</span>
                            <span class="circle"></span>
                            <svg viewBox="0 0 24 24" class="arr-1" xmlns="http://www.w3.org/2000/svg">
                                <path
                                d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z"
                                ></path>
                            </svg>
                            </button>

                        </div>
                    </div>
                {/* Service Two Branding */}
                    <div className="col-mds-4 d-flex justify-content-center mb-4 " >
                        <div className={` services serv-two w-100 rounded-3 ${darkMode ? "bg-darkMode" : "bg-lightMode"}`}>
                            <div className='d-flex flex-wrap w-100 align-items-center justify-content-between border-bottom mb-4 pb-3'>
                            <h2 className='responsive-HXtext fw-bold pt-3'>Branding</h2>
                                <MdOutlineDesignServices   size={40} className='service-icon'/>
                        </div>
                        <p className='responsive-text mb-3'>Crafting Unique, Memorable, and Impactful Brand Identities That Stand Out.</p>
                        <div>
                            <p className='responsive-text mb-3'><FaFingerprint /> Strong Identity</p>
                            <p className='responsive-text mb-3'><FaShieldAlt  /> Trust & Credibility</p>
                        </div>
                        <button class="animated-button" onClick={( ) => window.open("https://wa.me/201021699255/","_blank" )}>
                            <svg viewBox="0 0 24 24" class="arr-2" xmlns="http://www.w3.org/2000/svg">
                                <path
                                d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z"
                                ></path>
                            </svg>
                            <span class="text">Contact US</span>
                            <span class="circle"></span>
                            <svg viewBox="0 0 24 24" class="arr-1" xmlns="http://www.w3.org/2000/svg">
                                <path
                                d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z"
                                ></path>
                            </svg>
                            </button>

                        </div>
                    </div>
                {/* Service Three Ecommerce */}
                    <div className="col-mds-4 d-flex justify-content-center mb-4 " >
                        <div className={` services serv-three  w-100 rounded-3 ${darkMode ? "bg-darkMode" : "bg-lightMode"}`}>
                            <div className='d-flex flex-wrap w-100 align-items-center justify-content-between border-bottom mb-4 pb-3'>
                            <h2 className='responsive-HXtext fw-bold pt-3'>Ecommerce</h2>
                                <AiOutlineShopping   size={40} className='service-icon'/>
                        </div>
                        <p className='responsive-text mb-3'>Powerful & Scalable E-Commerce Solutions for a Seamless Shopping Experience.</p>
                        <div>
                            <p className='responsive-text mb-3'><FaShoppingCart /> User-Friendly Experience</p>
                            <p className='responsive-text mb-3'><FaLock  /> Secure & Fast Transactions</p>
                        </div>
                        <button class="animated-button" onClick={( ) => window.open("https://wa.me/201021699255/","_blank" )}>
                            <svg viewBox="0 0 24 24" class="arr-2" xmlns="http://www.w3.org/2000/svg">
                                <path
                                d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z"
                                ></path>
                            </svg>
                            <span class="text">Contact US</span>
                            <span class="circle"></span>
                            <svg viewBox="0 0 24 24" class="arr-1" xmlns="http://www.w3.org/2000/svg">
                                <path
                                d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z"
                                ></path>
                            </svg>
                            </button>

                        </div>
                    </div>
                {/* Service Four Marketing */}
                    <div className="col-mds-4 d-flex justify-content-center mb-4 " >
                        <div className={` services serv-four  w-100 rounded-3 ${darkMode ? "bg-darkMode" : "bg-lightMode"}`}>
                            <div className='d-flex flex-wrap w-100 align-items-center justify-content-between border-bottom mb-4 pb-3'>
                            <h2 className='responsive-HXtext fw-bold pt-3'>Marketing</h2>
                                <FaBullhorn   size={40} className='service-icon'/>
                        </div>
                        <p className='responsive-text mb-3'>Innovative Marketing Strategies to Boost Brand Awareness, Drive Engagement, and Maximize Conversions.</p>
                        <div>
                            <p className='responsive-text mb-3'><BiBullseye /> Targeted Reach</p>
                            <p className='responsive-text mb-3'><MdInsights   /> Performance Analytics</p>
                        </div>
                        <button class="animated-button" onClick={( ) => window.open("https://wa.me/201021699255/","_blank" )}>
                            <svg viewBox="0 0 24 24" class="arr-2" xmlns="http://www.w3.org/2000/svg">
                                <path
                                d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z"
                                ></path>
                            </svg>
                            <span class="text">Contact US</span>
                            <span class="circle"></span>
                            <svg viewBox="0 0 24 24" class="arr-1" xmlns="http://www.w3.org/2000/svg">
                                <path
                                d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z"
                                ></path>
                            </svg>
                            </button>

                        </div>
                    </div>
                {/* Service Four Marketing */}
                    <div className="col-mds-4 d-flex justify-content-center mb-4 " >
                        <div className={` services serv-five  w-100 rounded-3 ${darkMode ? "bg-darkMode" : "bg-lightMode"}`}>
                            <div className='d-flex flex-wrap w-100 align-items-center justify-content-between border-bottom mb-4 pb-3'>
                            <h2 className='responsive-HXtext fw-bold pt-3'>ProVoice Over    </h2>
                                <MdRecordVoiceOver   size={40} className='service-icon'/>
                        </div>
                        <p className='responsive-text mb-3'>Versatile voice-over artist fluent in Egyptian, Modern Standard Arabic, Gulf dialect, and English. </p>
                        <div>
                            <p className='responsive-text mb-3'><MdHighQuality /> Studio-quality audio with editing</p>
                            <p className='responsive-text mb-3'><FaRocket   /> Quick delivery</p>
                        </div>
                        <button class="animated-button" onClick={( ) => window.open("https://wa.me/201021699255/","_blank" )}>
                            <svg viewBox="0 0 24 24" class="arr-2" xmlns="http://www.w3.org/2000/svg">
                                <path
                                d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z"
                                ></path>
                            </svg>
                            <span class="text">Contact US</span>
                            <span class="circle"></span>
                            <svg viewBox="0 0 24 24" class="arr-1" xmlns="http://www.w3.org/2000/svg">
                                <path
                                d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z"
                                ></path>
                            </svg>
                            </button>

                        </div>
                    </div>
            </div>
            </div>
            {/* End Animate with mouse move*/}

            </div>
            
        </div>
        <hr/>
    </div>
  )
});

export default Services